"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOrderDisplayTotal = void 0;
const getTotalOrderValue_1 = require("./getTotalOrderValue");
const getOrderDisplayTotal = (order, exchange_rate) => {
    if (!exchange_rate || exchange_rate?.rate === 1)
        return 0;
    // format to two decimal places return as number
    return Math.floor((0, getTotalOrderValue_1.getTotalOrderValue)(order) * exchange_rate.rate);
};
exports.getOrderDisplayTotal = getOrderDisplayTotal;
